<template>
  <section class="hw-footer_wrap">
    <footer class="clear">
      <!-- <h1>한화생명</h1> -->
      <div class="fl">©Hanwha. All rights reserved.</div>
      <ul class="list_corp clear">
        <li><a @click="showFooterContentModal('TERMS')" style="cursor: pointer;">{{ $i18nUtil.trans("title.UseTerms.001","이용약관") }}</a></li>
        <li v-if="$i18nUtil.getLanguage() === 'ko'"><a @click="showFooterContentModal('PRIVACY')" style="cursor: pointer;">{{ $i18nUtil.trans("title.PrivacyPolicy.001","개인정보 취급방침") }}</a></li>
        <li v-if="loginYn"><a @click="showServiceCenter" style="cursor: pointer;">{{ $i18nUtil.trans("title.HelpDesk.001","고객센터") }}</a></li>
        <!-- <li><a href="">이용약관</a></li>
        <li><a href="">개인정보 취급방침</a></li>
        <li><a href="">고객센터</a></li> -->
      </ul>
    </footer>
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex";
import FooterCotentModal from "./modal/FooterCotentModal";
export default {
  data() {
    return {
      Authorization : localStorage.getItem("Authorization"),
      loginYn : false,
    };
  },
  created(){
    if(this.Authorization != null){
      this.loginYn = true;
    }
  },
  methods: {
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    ...mapActions("modals", ["showModal"]),
    showFooterContentModal(type) {
      // const modalInfo = {
      //     width: "800px",
      //     height: "520px",
      //     obj: this.$modal,
      //     type : type,
      //     component: FooterCotentModal
      // };
      // this.showModal(modalInfo);
      let hanwha = $(location).attr("origin");
      console.log(hanwha)
      let frmPop = document.frm;
      window.open(
        hanwha + "/terms/" + type,
        "_blank",
        "width=800, height=520"
      );
    },
    showServiceCenter() {
      let hanwha = $(location).attr("origin");
      let obj = this;
      let reqData = {
        url : "/api/org/getCodeValueList",
        method : "post",
        params : {
          cdCategory: 'tenant.env',
          cdKey: 'external.service.use'
        }
      };
      obj
      .COWORK_REST_SIMPLE_ACTION(reqData)
      .then(function(res) {
        let codeList = res.result;
        if(codeList != null && codeList.length != 0){
          let isExternalService = codeList[0].cdValue;
          localStorage.setItem("isExternalServiceUse",isExternalService);
          if (isExternalService == "false") {
            window.open(hanwha + "/helpDesk", "_blank", "width=660, height=740");
          }else{
            window.open(hanwha + "/helpDesk", "_blank", "width=1264, height=740");
          }
        }else{
          localStorage.setItem("isExternalServiceUse", true);
          window.open(hanwha + "/helpDesk", "_blank", "width=1264, height=740");
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    }
  }
};
</script>

<style lang="css" scoped></style>



// WEBPACK FOOTER //
// src/components/cowork/general/main/MainFooter.vue